import React, { useState, useContext, useEffect } from "react";
import { CheckCircle } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import ShopButton from "../../elements/ShopButton";
import Header from "../../elements/Header";
import NavigationSimple from "../../elements/NavigationSimple";
import FAQ from "../../elements/FAQ";
import { useFirestore } from "../../firebase/FirestoreContext";
import { EnvContext } from "../../context/EnvContext";
import { UserContext } from "../../context/UserContext";
import config from "../../config";
import { doc, collection, addDoc, serverTimestamp, getDoc } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import PageLayout from "../../elements/PageLayout";
import RatingStars from "../../elements/RatingStars";

const breakpoints = [755]
const mq = breakpoints.map(bp => `@media (min-width: ${bp}px)`)

// Review Create Component
export const ReviewCreate = ({ onClose }) => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(0);
  const [product, setProduct] = useState(null);
  const [title, setTitle] = useState("");
  const [review, setReview] = useState("");
  const [submitted, setSubmitted] = useState(false); // Track if the review has been submitted
  const [canReview, setCanReview] = useState(false); // Track if the user can review the product
  const db = useFirestore();
  const environment = useContext(EnvContext);
  const { recentlyPurchasedProducts } = useContext(UserContext);
  const auth = getAuth();
  const user = auth.currentUser;
  const collectionPath = environment === "staging" ? config.environment.staging.collectionPath : config.environment.production.collectionPath;
  // get id from url
  const { productID } = useParams();

  // get product from firebase
  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const productDoc = doc(db, `${collectionPath}Products/ProductsList/DataBase/${productID}`);
        const productSnapshot = await getDoc(productDoc);

        if (productSnapshot.exists()) {
          setProduct(productSnapshot.data());
        } else {
          console.error("No such document!");
        }
      } catch (error) {
        console.error("Error fetching product:", error);
      }
    };
    fetchProduct();
  }, [db, productID, collectionPath]);
  // Check if the user can review the product

  useEffect(() => {
    if (recentlyPurchasedProducts && productID) {
      // Check if the product is in the recently purchased products
      const purchased = recentlyPurchasedProducts.some((item) => item.product_id === productID);
      setCanReview(purchased);
    } else {
      setCanReview(false); // If recentlyPurchasedProducts or productID is not available, disable review
    }
  }, [recentlyPurchasedProducts, productID]);

  const handleSubmit = async () => {
    if (!title) {
      alert("Please give a title for your review.");
      return;
    }

    if (!rating) {
      alert("Please give a star rating for your review.");
      return;
    }

    try {
      const reviewsCollection = collection(db, `${collectionPath}Products/ProductsList/DataBase/${productID}/Reviews`);
      await addDoc(reviewsCollection, {
        rating: rating,
        title: title,
        comment: review,
        user_uid: user.uid,
        date: serverTimestamp(),
        // Optionally add user name or other details
      });
      setSubmitted(true);
    } catch (error) {
      console.error("Error submitting review:", error);
      alert("Failed to submit review. Please try again.");
    }
  };

  const handleRating = (value) => {
    setRating(value); // Set the rating based on the star clicked
  };

  console.log({ product })

  let content = submitted ? (
    <div css={styles.container}>
      <div css={{ display: "flex", color: "#0E9203", flexDirection: "row", alignItems: "center" }}>
        <CheckCircle css={styles.fontSmall} />
        <div css={{ ...styles.fontSmall, marginLeft: 5, fontWeight: 600 }}>Review Submitted</div>
      </div>
      <div css={{ display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column" }}>
        <div css={{ display: "flex", justifyContent: "center" }}>
          {
            // image
            product?.images && product.images.length > 0 ? (
              <img
                src={product.images[0]}
                alt={product.name}
                css={{ width: "50%", height: "auto", borderRadius: 8, marginTop: 8, maxWidth: "500px" }}
              />
            ) : (
              <img src={"/images/no_product_image.png"} alt={product?.name} css={{ width: 200, height: 200, borderRadius: 8 }} />
            )
          }
        </div>
        <div css={{ padding: "10px 0" }}>
          <RatingStars value={rating} readOnly iconStyle={{ fontSize: "2rem" }} />
        </div>
        <div css={{ ...styles.fontLarge, fontWeight: 800, marginTop: 10 }}>Thank you!</div>
        <div css={{ height: 20 }} />
        <div css={{ ...styles.fontNormal, padding: "0px 20px", marginBottom: "20px" }}>
          Your reviews help us curate the best of products and experiences.
          <br /> <br />
          Once your submission is reviewed by our team for adherence to community guidelines, it will be posted for public viewing.
        </div>

        <ShopButton
          text={"Keep Shopping"}
          containerStyles={styles.shop.button}
          buttonStyle={styles.shop.text}
          theme={"dark"}
          onClick={
            // go to home page
            () => {
              navigate("/shop");
            }
          }
        />
      </div>
    </div>
  ) : (
    <div css={styles.container}>
      <div css={styles.header}>
        <div css={{ ...styles.header.title, display: "flex", flexDirection: "row", alignItems: "center" }}>
          {
            // image
            product?.images && product.images.length > 0 ? (
              <img src={product.images[0]} alt={product.name} width={120} height={120} css={styles.image} />
            ) : (
              <img src={"/images/no_product_image.png"} alt={product?.name} width={120} height={120} css={styles.image} />
            )
          }
          <div css={{ ...styles.fontMedium, paddingLeft: 10, fontWeight: 600 }}>
            {canReview ? "How was the item?" : "Once you purchase this item, you can review it!"}
          </div>
        </div>
        <div css={styles.header.rating}>
          <RatingStars value={rating} onChange={handleRating} iconStyle={styles.fontLarge} disabled={!canReview} />
        </div>
      </div>
      <div css={styles.content}>
        
        <div css={styles.contentName}>
          <span css={{ fontWeight: 600 }}>Write a review</span> (optional)
        </div>
        <div css={styles.review}>
          <textarea
            css={styles.textarea}
            value={review}
            onChange={(e) => setReview(e.target.value)}
            placeholder="What should other customers know?"
            disabled={!canReview}
          />
        </div>
        <div css={styles.contentName}>
          <span css={{ fontWeight: 600 }}>Title your review</span> (required)
        </div>
        <div css={styles.review}>
          <input
            css={styles.input}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="What’s most important to know?"
            disabled={!canReview}
          />
        </div>
      </div>
      <div css={{ ...styles.footer }}>
        <ShopButton
          text={"Submit"}
          outlined
          containerStyles={{ ...styles.shop.button, opacity: canReview ? 1 : 0.5 }}
          buttonStyle={{ ...styles.shop.text }}
          onClick={handleSubmit}
          disabled={!canReview}
        />
      </div>
    </div>
  );

  return (
    <PageLayout analyticsView="create_rating" analyticsTitle="Create Rating Page" description={`Write a review for ${product?.brand_name}'s ${product?.product_name}`} imageUrl={product?.images?.[0]} title={`Review ${product?.product_name} by ${product?.brand_name}`} >
      <Header search={false} />
      <div css={styles.wrapper}>
        <div css={{ height: 20 }} />
        {/* Product Images Section */}
        <NavigationSimple />
        <div css={{ borderBottom: "1px solid black", marginBottom: 15 }} />
        <div css={styles.container}>
          {/* Product Images Section */}
          <div css={{ ...styles.content.container }}>{content}</div>
        </div>
        <FAQ />
      </div>
    </PageLayout>
  );
};

const styles = {
  wrapper: {
    maxWidth: "1140px",
    margin: "0 auto",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    margin: "8px 0",
    marginBottom: 30,
  },
  content: {
    container: {
      margin: "0px 10px",
    },
  },
  header: {
    display: "flex",
    flexDirection: "column",
    title: {
      fontWeight: "500",
      paddingBottom: 10,
    },
    rating: {
      display: "flex",
      flexDirection: "row",
      text: {
        marginLeft: 8,
        fontSize: "1rem",
        fontWeight: "bold",
        [mq[0]]: {
          fontSize: "1.1rem",
        },
      },
    },
  },
  fontSmall: {
    fontSize: ".9rem",
    [mq[0]]: {
      fontSize: "1.1rem",
    },
  },
  fontNormal: {
    fontSize: "1rem",
    [mq[0]]: {
      fontSize: "1.25rem",
    },
  },
  fontMedium: {
    fontSize: "1.4rem",
    [mq[0]]: {
      fontSize: "1.75rem",
    },
  },
  fontLarge: {
    fontSize: "1.5rem",
    [mq[0]]: {
      fontSize: "2rem",
    },
  },
  image: {
    width: "90px",
    height: "90px",
    [mq[0]]: {
      width: "160px",
      height: "160px",
    },
  },
  contentName: {
    fontWeight: 500,
    paddingBottom: 2,
  },
  review: {
    fontSize: 14,
    lineHeight: 1.5,
  },
  textarea: {
    fontSize: ".9rem",
    width: "100%",
    height: "100px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    marginBottom: "10px",
    [mq[0]]: {
      fontSize: "1rem",
    },
  },
  input: {
    fontSize: ".9rem",
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ddd",
    marginBottom: "10px",
    [mq[0]]: {
      fontSize: "1rem",
    },
  },
  footer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 12,
  },
  voteUp: {
    padding: "6px 16px",
    border: "1px solid black",
    borderRadius: 50,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
    cursor: "pointer",
  },
  shop: {
    button: {
      margin: "0px auto",
      width: "100%",
      maxWidth: "380px",
    },
    text: {
      fontSize: "1rem",
      lineHeight: "1rem",
      [mq[0]]: {
        fontSize: "1.25rem",
        lineHeight: "1.25rem",
      },
    }
  },
};

export default ReviewCreate;
